module.exports = __webpack_public_path__ + "img/长.bdb6b975.png";